import { render, staticRenderFns } from "./GetDriverTableDataComponent.vue?vue&type=template&id=f79d1cd2&scoped=true&"
import script from "./GetDriverTableDataComponent.vue?vue&type=script&lang=js&"
export * from "./GetDriverTableDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79d1cd2",
  null
  
)

export default component.exports